import { useState } from "react";

interface Community {
  name: string;
  route: string;
}

interface Subregion {
  name: string;
  description: string;
  communities: Community[];
  hub: { name: string; route: string };
  countyHub?: { name: string; route: string };
}

interface Region {
  id: string;
  name: string;
  icon: string;
  subregions: Subregion[];
}

const regions: Region[] = [
  {
    id: "detroit-metro",
    name: "Detroit Metro",
    icon: "ri-building-2-line",
    subregions: [
      {
        name: "Detroit & Downriver",
        description: "Detroit, Dearborn, Dearborn Heights, Taylor, and Lincoln Park are all within 30 minutes of Detroit Metro Airport (DTW). The I-75, I-94, and I-96 corridors connect the metro area. Downtown Detroit and Corktown are directly east of the airport.",
        hub: { name: "Detroit", route: "/detroit" },
        communities: [
          { name: "Dearborn", route: "/dearborn" }, { name: "Dearborn Heights", route: "/dearborn-heights" },
          { name: "Taylor", route: "/taylor" }, { name: "Inkster", route: "#" },
          { name: "Westland", route: "/westland" }, { name: "Garden City", route: "#" },
          { name: "Romulus", route: "#" }, { name: "Wayne", route: "#" },
          { name: "Lincoln Park", route: "#" }, { name: "Allen Park", route: "#" },
          { name: "Melvindale", route: "#" }, { name: "Riverview", route: "#" },
          { name: "Trenton", route: "#" }, { name: "Wyandotte", route: "#" },
          { name: "Grosse Pointe", route: "#" }, { name: "Hamtramck", route: "#" },
        ],
      },
      {
        name: "Oakland County",
        description: "Troy, Pontiac, Royal Oak, Southfield, and Rochester Hills form the northern business corridor. The I-75, I-696, and M-59 connect the northern suburbs. Birmingham and Bloomfield Hills are affluent enclaves along the Woodward corridor.",
        hub: { name: "Troy", route: "/troy-mi" },
        communities: [
          { name: "Pontiac", route: "/pontiac" }, { name: "Royal Oak", route: "/royal-oak" },
          { name: "Southfield", route: "/southfield" }, { name: "Rochester Hills", route: "/rochester-hills" },
          { name: "Birmingham", route: "#" }, { name: "Bloomfield Hills", route: "#" },
          { name: "Farmington Hills", route: "/farmington-hills" }, { name: "Novi", route: "/novi" },
          { name: "Waterford", route: "#" }, { name: "Auburn Hills", route: "#" },
          { name: "Madison Heights", route: "#" }, { name: "Ferndale", route: "#" },
          { name: "Berkley", route: "#" }, { name: "Clawson", route: "#" },
          { name: "Walled Lake", route: "#" }, { name: "Wixom", route: "#" },
        ],
      },
      {
        name: "Macomb County",
        description: "Sterling Heights, Warren, and Roseville are the eastern suburbs along the I-696 and I-94 corridors. The area is known for its manufacturing base. Mount Clemens is the county seat. The Blue Water Bridge connects to Canada.",
        hub: { name: "Sterling Heights", route: "/sterling-heights" },
        countyHub: { name: "Macomb County Hub", route: "/macomb-county" },
        communities: [
          { name: "Warren", route: "/warren" }, { name: "Roseville", route: "/roseville-mi" },
          { name: "Clinton Township", route: "/clinton-township" }, { name: "Fraser", route: "#" },
          { name: "Shelby Township", route: "#" }, { name: "Utica", route: "#" },
          { name: "Mount Clemens", route: "#" }, { name: "Eastpointe", route: "/eastpointe" },
          { name: "Saint Clair Shores", route: "/saint-clair-shores" }, { name: "Center Line", route: "#" },
          { name: "New Baltimore", route: "#" }, { name: "Chesterfield", route: "#" },
          { name: "Harrison Township", route: "#" }, { name: "Richmond", route: "#" },
          { name: "Romeo", route: "#" }, { name: "Armada", route: "#" },
        ],
      },
    ],
  },
  {
    id: "west-michigan",
    name: "West Michigan",
    icon: "ri-anchor-line",
    subregions: [
      {
        name: "Grand Rapids Area",
        description: "Grand Rapids, Kentwood, Wyoming, and Walker are the core of West Michigan. Gerald R. Ford International Airport (GRR) is the region's airport. The I-96, I-196, and US-131 corridors connect the area. Grand Rapids is the second largest city in Michigan.",
        hub: { name: "Grand Rapids", route: "/grand-rapids" },
        countyHub: { name: "Kent County Hub", route: "/kent-county" },
        communities: [
          { name: "Kentwood", route: "/kentwood" }, { name: "Wyoming", route: "/wyoming" },
          { name: "Walker", route: "#" }, { name: "Grandville", route: "#" },
          { name: "East Grand Rapids", route: "#" }, { name: "Byron Center", route: "#" },
          { name: "Cutlerville", route: "#" }, { name: "Caledonia", route: "#" },
          { name: "Ada", route: "#" }, { name: "Cascade", route: "#" },
          { name: "Rockford", route: "#" }, { name: "Sparta", route: "#" },
          { name: "Comstock Park", route: "#" }, { name: "Northview", route: "#" },
          { name: "Forest Hills", route: "#" }, { name: "Jenison", route: "#" },
        ],
      },
      {
        name: "Lake Michigan Shore",
        description: "Holland, Grand Haven, Muskegon, St. Joseph, and Ludington are the coastal cities on Lake Michigan. The lakeshore communities draw heavy summer tourism. The I-196 and US-31 run along the coast. The ferry to Milwaukee departs from Muskegon.",
        hub: { name: "Holland", route: "/holland" },
        countyHub: { name: "Ottawa County Hub", route: "/ottawa-county" },
        communities: [
          { name: "Grand Haven", route: "/grand-haven" }, { name: "Muskegon", route: "/muskegon" }, { name: "St. Joseph", route: "/st-joseph-mi" },
          { name: "Ludington", route: "/ludington" }, { name: "Saugatuck", route: "#" },
          { name: "Douglas", route: "#" }, { name: "Fennville", route: "#" },
          { name: "Zeeland", route: "#" }, { name: "Hudsonville", route: "#" },
          { name: "Norton Shores", route: "#" }, { name: "Roosevelt Park", route: "#" },
          { name: "Fruitport", route: "#" }, { name: "Whitehall", route: "#" },
          { name: "Montague", route: "#" }, { name: "Benton Harbor", route: "#" },
          { name: "Stevensville", route: "#" }, { name: "Manistee", route: "/manistee" },
        ],
      },
    ],
  },
  {
    id: "central-michigan",
    name: "Central & Mid-Michigan",
    icon: "ri-landscape-line",
    subregions: [
      {
        name: "Lansing Capital Area",
        description: "Lansing, East Lansing, and Okemos form the state capital region. Michigan State University is in East Lansing, generating significant student and faculty travel. The I-96 and I-69 corridors connect the area. Capital Region International (LAN) is the local airport.",
        hub: { name: "Lansing", route: "/lansing-mi" },
        communities: [
          { name: "East Lansing", route: "#" }, { name: "Okemos", route: "#" },
          { name: "Haslett", route: "#" }, { name: "Holt", route: "#" },
          { name: "Mason", route: "#" }, { name: "Waverly", route: "#" },
          { name: "Grand Ledge", route: "#" }, { name: "DeWitt", route: "#" },
          { name: "St. Johns", route: "#" }, { name: "Charlotte", route: "#" },
          { name: "Eaton Rapids", route: "#" }, { name: "Potterville", route: "#" },
          { name: "Dimondale", route: "#" }, { name: "Williamston", route: "#" },
          { name: "Webberville", route: "#" }, { name: "Fowlerville", route: "#" },
        ],
      },
      {
        name: "Flint & Saginaw Bay",
        description: "Flint, Saginaw, and Bay City form the Saginaw Bay region. The area is historically industrial. The I-75 and I-69 are the major corridors. Bishop International (FNT) is the airport. Frankenmuth is a popular tourist destination.",
        hub: { name: "Flint", route: "/flint" },
        communities: [
          { name: "Saginaw", route: "/saginaw" }, { name: "Bay City", route: "/bay-city" },
          { name: "Grand Blanc", route: "/grand-blanc" }, { name: "Burton", route: "#" },
          { name: "Davison", route: "#" }, { name: "Fenton", route: "#" },
          { name: "Holly", route: "#" }, { name: "Linden", route: "#" },
          { name: "Goodrich", route: "#" }, { name: "Swartz Creek", route: "#" },
          { name: "Frankenmuth", route: "#" }, { name: "Freeland", route: "#" },
          { name: "Essexville", route: "#" }, { name: "Auburn", route: "#" },
          { name: "Midland", route: "/midland" }, { name: "Mount Pleasant", route: "#" },
        ],
      },
    ],
  },
  {
    id: "southwest-michigan",
    name: "Southwest & South Central",
    icon: "ri-sun-line",
    subregions: [
      {
        name: "Kalamazoo & Battle Creek",
        description: "Kalamazoo, Portage, and Battle Creek are the Southwest Michigan core. Western Michigan University and Kalamazoo College are in the area. The I-94 corridor connects to Chicago. Kalamazoo/Battle Creek International (AZO) is the regional airport.",
        hub: { name: "Kalamazoo", route: "/kalamazoo" },
        communities: [
          { name: "Portage", route: "/portage" }, { name: "Battle Creek", route: "/battle-creek" },
          { name: "Comstock", route: "#" }, { name: "Oshtemo", route: "#" },
          { name: "Texas", route: "#" }, { name: "Schoolcraft", route: "#" },
          { name: "Parchment", route: "#" }, { name: "Marshall", route: "#" },
          { name: "Albion", route: "#" }, { name: "Springfield", route: "#" },
          { name: "Galesburg", route: "#" }, { name: "Augusta", route: "#" },
          { name: "Vicksburg", route: "#" }, { name: "Climax", route: "#" },
          { name: "Athens", route: "#" }, { name: "Union City", route: "#" },
        ],
      },
      {
        name: "Jackson & South Central",
        description: "Jackson, Adrian, and Monroe are the South Central Michigan communities. The US-127 and I-94 connect the area. Jackson County is the gateway to the Irish Hills. The Michigan International Speedway is in the area.",
        hub: { name: "Jackson", route: "/jackson-mi" },
        communities: [
          { name: "Adrian", route: "/adrian" }, { name: "Monroe", route: "/monroe" },
          { name: "Tecumseh", route: "#" }, { name: "Blissfield", route: "#" },
          { name: "Clinton", route: "#" }, { name: "Parma", route: "#" },
          { name: "Spring Arbor", route: "#" }, { name: "Michigan Center", route: "#" },
          { name: "Grass Lake", route: "#" }, { name: "Hanover", route: "#" },
          { name: "Dundee", route: "#" }, { name: "Lambertville", route: "#" },
          { name: "Temperance", route: "#" }, { name: "Erie", route: "#" },
          { name: "Luna Pier", route: "#" }, { name: "Petersburg", route: "#" },
        ],
      },
    ],
  },
  {
    id: "northern-michigan",
    name: "Northern Michigan & UP",
    icon: "ri-snowy-line",
    subregions: [
      {
        name: "Traverse City & North Lower",
        description: "Traverse City, Petoskey, and Charlevoix are the Northern Michigan tourist hubs. The area is known for cherries, wine, and summer tourism. Cherry Capital Airport (TVC) is the regional airport. The Leelanau Peninsula is a major wine region.",
        hub: { name: "Traverse City", route: "/traverse-city" },
        communities: [
          { name: "Petoskey", route: "/petoskey" }, { name: "Charlevoix", route: "#" },
          { name: "Harbor Springs", route: "#" }, { name: "Gaylord", route: "#" },
          { name: "Cadillac", route: "#" }, { name: "Mancelona", route: "#" },
          { name: "Kalkaska", route: "#" }, { name: "Elk Rapids", route: "#" },
          { name: "Interlochen", route: "#" }, { name: "Frankfort", route: "#" },
          { name: "Beulah", route: "#" }, { name: "Benzonia", route: "#" },
          { name: "Onekama", route: "#" }, { name: "Bear Lake", route: "#" },
          { name: "Empire", route: "#" }, { name: "Glen Arbor", route: "#" },
        ],
      },
      {
        name: "Upper Peninsula",
        description: "Marquette, Sault Ste. Marie, Escanaba, and Houghton are the UP's major communities. The area is remote and far from passport agencies. The Mackinac Bridge connects the UP to the Lower Peninsula. Sawyer International (MQT) is the UP's airport.",
        hub: { name: "Marquette", route: "#" },
        communities: [
          { name: "Sault Ste. Marie", route: "/sault-ste-marie" }, { name: "Escanaba", route: "/escanaba" },
          { name: "Houghton", route: "/houghton" }, { name: "Hancock", route: "#" },
          { name: "Negaunee", route: "#" }, { name: "Ishpeming", route: "#" },
          { name: "Gladstone", route: "#" }, { name: "Manistique", route: "#" },
          { name: "St. Ignace", route: "#" }, { name: "Mackinaw City", route: "#" },
          { name: "Newberry", route: "#" }, { name: "Munising", route: "#" },
          { name: "Calumet", route: "#" }, { name: "Laurium", route: "#" },
          { name: "Copper Harbor", route: "#" }, { name: "Iron Mountain", route: "#" },
        ],
      },
    ],
  },
];

export default function MichiganCommunitiesWeServe() {
  const [activeRegion, setActiveRegion] = useState(regions[0].id);

  const current = regions.find((r) => r.id === activeRegion) || regions[0];

  return (
    <section id="communities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Statewide Coverage
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Communities We Serve Across Michigan
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Don't see your city in the directory above? You're still covered. Every Michigan community below is served through our nearest hub — with the same fast, reliable expedited passport processing.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {regions.map((region) => (
            <button
              key={region.id}
              onClick={() => setActiveRegion(region.id)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeRegion === region.id
                  ? "bg-[#1A365D] text-white"
                  : "bg-[#EEF2F8] text-[#1A365D] hover:bg-[#dce5f3]"
              }`}
            >
              <i className={`${region.icon} text-base`}></i>
              {region.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {current.subregions.map((sub, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-100">
              <div className="flex items-start justify-between gap-4 mb-3">
                <h3 className="font-bold text-[#1A365D] text-base">{sub.name}</h3>
                <div className="flex flex-wrap gap-1.5 flex-shrink-0">
                  {sub.countyHub && (
                    sub.countyHub.route !== "#" ? (
                      <a
                        href={sub.countyHub.route}
                        className="inline-flex items-center gap-1 bg-[#F6C344] text-[#1A365D] text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-[#F6C344]/80 transition-all whitespace-nowrap"
                      >
                        <i className="ri-map-2-line"></i>
                        County Hub
                      </a>
                    ) : (
                      <span className="inline-flex items-center gap-1 bg-[#F6C344] text-[#1A365D] text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap">
                        <i className="ri-map-2-line"></i>
                        County Hub
                      </span>
                    )
                  )}
                  {sub.hub.route !== "#" ? (
                    <a
                      href={sub.hub.route}
                      className="inline-flex items-center gap-1 bg-[#1A365D] text-white text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap"
                    >
                      Hub: {sub.hub.name} <i className="ri-arrow-right-line"></i>
                    </a>
                  ) : (
                    <span className="inline-flex items-center gap-1 bg-[#1A365D] text-white text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap">
                      Hub: {sub.hub.name}
                    </span>
                  )}
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{sub.description}</p>
              <div className="flex flex-wrap gap-2">
                {sub.communities.map((c, j) => (
                  c.route !== "#" ? (
                    <a
                      key={j}
                      href={c.route}
                      className="inline-flex items-center text-xs font-medium text-[#1A365D] bg-white border border-gray-200 rounded-full px-3 py-1 hover:border-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap cursor-pointer"
                    >
                      {c.name}
                    </a>
                  ) : (
                    <span
                      key={j}
                      className="inline-flex items-center text-xs font-medium text-[#6B7280] bg-white border border-gray-200 rounded-full px-3 py-1 whitespace-nowrap"
                    >
                      {c.name}
                    </span>
                  )
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-400 text-sm mt-8">
          Not finding your exact community? <a href="tel:8772530084" className="text-[#1A365D] font-semibold hover:text-[#F6C344] transition-colors">Call us at 877-253-0084</a> — we serve all of Michigan.
        </p>
      </div>
    </section>
  );
}